import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../../utility-services/auth.service';
import { LanguageService } from '../../utility-services/language.service';

@Injectable({
  providedIn: 'root',
})
export class TokenGuard implements CanActivate {
  private authService = inject(AuthService);
  private languageService = inject(LanguageService);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    if (!this.authService.isAuthenticated) {
      return true;
    }

    const returnUrl = route.queryParamMap.get('returnUrl') ?? undefined;

    const language = route.queryParamMap.get('lang');

    if (language) {
      this.languageService.setCurrentLanguage(language);
    }

    await this.authService.redirectAfterAuthentication(returnUrl);

    return false;
  }
}
